import React from "react";
import styled from "styled-components";

// Fonction pour extraire l'image du contenu HTML de l'article
const extractImageUrl = (html) => {
  if (!html) return null;
  const doc = new DOMParser().parseFromString(html, "text/html");
  const image = doc.querySelector("img");
  return image ? image.src : null;
};

const BlogCard = ({ article }) => {
  if (!article) {
    return <p>No article data available</p>;
  }

  const imageUrl = extractImageUrl(article.content);

  return (
    <Card>
      {imageUrl && <Image src={imageUrl} alt="Image de l'article" />}
      <Content>
        <Title>{article.title || "No title available"}</Title>
      </Content>
    </Card>
  );
};

export default BlogCard;

// Styled Components
const Card = styled.div`
  background-color: #fff;
  color: #333;
  border: 2px solid black;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 270px;
  height: 100%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 200px;
  border-radius: 8px;
  margin-bottom: 10px;
  object-fit: cover;
`;

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: 300;
  color: #333;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
  font-family: 'caveat', sans-serif;
`;
